export default __webpack_public_path__ + "static/media/cancel-white.499bbdfb.svg";